import { z } from "zod";
import { dateSchema } from "@/types/schemas/date";

export type CustomDate = z.infer<typeof dateSchema>;

export const personCommonSchema = z.object({
  id: z.number().or(z.string()),
  name: z.preprocess(name => (name === null ? "" : name), z.string()),
  surname: z.preprocess(name => (name === null ? "" : name), z.string()),
  degreeAfterId: z.preprocess(name => (name === null ? "" : name), z.string()),
  degreeBeforeId: z.preprocess(name => (name === null ? "" : name), z.string()),
  degreeBeforeId2: z.preprocess(name => (name === null ? "" : name), z.string()),
  birthDate: dateSchema,
});

export const executivePersonSchema = personCommonSchema.merge(
  z.object({
    main: z.boolean(),
    email: z.preprocess(name => (name === null ? "" : name), z.string()),
    mobilePhone: z.preprocess(name => (name === null ? "" : name), z.string()),
    mobileCountryCode: z.string().optional(),
    phone: z.preprocess(name => (name === null ? "" : name), z.string()),
    executiveRoleId: z.preprocess(name => (name === null ? "" : name), z.string().nullable()),
    executiveRoleCustom: z.preprocess(name => (name === null ? "" : name), z.string()),
    editable: z.boolean(),
    referenceType: z.number().nullable(),
  })
);
